function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "money-refund_svg__a",
  d: "M0 63.429h80.914V0H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.543 14.743)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.514 36.171a8.743 8.743 0 01-8.743 8.743 8.743 8.743 0 118.743-8.743",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.6 29.143a6.857 6.857 0 110 13.715 6.857 6.857 0 010-13.715",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.086 36c0 3.787 3.015 6.857 6.734 6.857l.123-.003V29.146l-.123-.003c-3.72 0-6.734 3.07-6.734 6.857",
  fill: "#F8FBCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.714 23.486a8.743 8.743 0 11-17.486 0 8.743 8.743 0 0117.486 0m-19.2-14.743a8.743 8.743 0 11-17.485 0A8.743 8.743 0 0145.77 0a8.743 8.743 0 018.743 8.743",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.449 13.763a6.858 6.858 0 11-9.698-9.699 6.858 6.858 0 019.698 9.7",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("mask", {
  id: "money-refund_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#money-refund_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#AA133D",
  mask: "url(#money-refund_svg__b)",
  d: "M0 63.429h20.914V32.914H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.914 37.714h11.5l24.595 4.5V48l18.89-5.702a3.89 3.89 0 014.76 2.36 3.93 3.93 0 01-1.928 4.916l-28.11 13.855-22.68-5.786h-7.027V37.714z",
  fill: "#FFD6C9",
  mask: "url(#money-refund_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FF5636",
  strokeWidth: 4,
  mask: "url(#money-refund_svg__b)",
  d: "M42.514 48.171h14.743"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.472 3.758a6.643 6.643 0 00-9.587 0l-.085.092 9.582 9.864.09-.087c2.647-2.725 2.647-7.144 0-9.869",
  fill: "#F8FBCF",
  mask: "url(#money-refund_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.951 18.808a6.858 6.858 0 119.698 9.7 6.858 6.858 0 01-9.698-9.7",
  fill: "#FFCE32",
  mask: "url(#money-refund_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.928 28.47a6.643 6.643 0 009.587 0 2.5 2.5 0 00.085-.092l-9.582-9.864-.09.088c-2.647 2.725-2.647 7.143 0 9.869",
  fill: "#F8FBCF",
  mask: "url(#money-refund_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.429 58.114a1.885 1.885 0 11-3.771 0 1.885 1.885 0 013.77 0m-6.514 0a1.886 1.886 0 11-3.771 0 1.886 1.886 0 013.771 0",
  fill: "#FF5636",
  mask: "url(#money-refund_svg__b)"
}));

const SvgMoneyRefund = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96
}, props), _ref, _ref2);

export default SvgMoneyRefund;